/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl, FormattedMessage } from 'react-intl';
import { useUrlGenerator } from '@micromag/core/contexts';
import { Link } from '@micromag/core/components';
import { useOtherLocales } from '@micromag/intl';

import { getFormatValues } from '../../../lib/utils';
import logo from '../../../../img/logo.svg';

import styles from '../../../../styles/guest/partials/header.module.scss';

const propTypes = {
    withLogo: PropTypes.bool,
    onLogoClick: PropTypes.func,
    onContactClick: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    withLogo: false,
    onLogoClick: null,
    onContactClick: null,
    className: null,
};

const Header = ({ withLogo, onLogoClick, onContactClick, className }) => {
    const { locale } = useIntl();
    const url = useUrlGenerator();
    const locales = useOtherLocales();
    return (
        <header
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.withLogo]: withLogo,
                },
            ])}
        >
            <div className={styles.content}>
                <button
                    className={styles.logoLink}
                    type="button"
                    aria-label="Logo"
                    onClick={onLogoClick}
                >
                    <img className={styles.logo} src={logo} alt="Micromag" />
                </button>
                <ul className={styles.menu}>
                    <li>
                        <button type="button" aria-label="Contact" onClick={onContactClick}>
                            <FormattedMessage
                                defaultMessage="Contact"
                                description="Contact link label"
                                values={getFormatValues()}
                            />
                        </button>
                    </li>
                    <li>
                        <Link
                            href={`${url('auth.login')}?locale=${locale}`}
                            external
                            target="_self"
                            className={styles.button}
                        >
                            <FormattedMessage
                                defaultMessage="Log in"
                                description="Login link label"
                                values={getFormatValues()}
                            />
                        </Link>
                    </li>
                    {locales.map((it) => (
                        <li key={`locale-${it}`}>
                            <Link
                                className={styles.locale}
                                href={url('public.home.locale', {
                                    locale: it,
                                })}
                                external
                                target="_self"
                            >
                                {it}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </header>
    );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
